// 목록 화면을 떠날 때 스크롤 위치와 마지막으로 누른 행을 목록 URL별로 보관했다가, 같은 목록으로 돌아와 다시 그린 뒤 한 번만 꺼내 쓴다.
const saved_positions = Object.create(null);

export function saveListScroll(key, row_key) {
	if (!key) return;
	saved_positions[key] = { x: window.pageXOffset, y: window.pageYOffset, row_key: row_key === undefined ? null : row_key };
}

export function takeListScroll(key) {
	if (!key || !saved_positions[key]) return null;
	const position = saved_positions[key];
	delete saved_positions[key];
	return position;
}
